import { useState } from 'react';
import { Switch } from '~/components/ui/switch';
import { useUpdateNotificationPreferences } from './useUpdateNotificationPreferences';

interface Props { optedIn: boolean }

// One login's grade-email preference. Off by default (Seth, Sept 3 2026);
// Phase 5 replaces this with per-event notification preferences.
export function GradeEmailPreference({ optedIn }: Props) {
  const [checked, setChecked] = useState(optedIn);
  const [error, setError] = useState<string | null>(null);
  const [update, { loading }] = useUpdateNotificationPreferences();

  const onChange = async (next: boolean) => {
    setError(null);
    setChecked(next);
    try {
      const result = await update({ variables: { input: { gradePostedEmailOptIn: next } } });
      const payload = result.data?.updateNotificationPreferences;
      const message = payload?.userErrors?.[0]?.message;
      if (message || !payload?.user) {
        setChecked(!next);
        setError(message ?? 'Could not save your preference.');
      }
    } catch (e) {
      setChecked(!next);
      setError(e instanceof Error ? e.message : 'Could not save your preference.');
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <Switch
          id="grade-email-opt-in"
          checked={checked}
          onCheckedChange={onChange}
          disabled={loading}
        />
        <label htmlFor="grade-email-opt-in" className="text-sm">Email me when new grades are posted</label>
      </div>
      <p className="text-xs text-muted-foreground">Off unless you turn it on. One email per posted assignment.</p>
      {error && <p role="alert" className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
